import { MouseEvent, RefObject } from 'react';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import withCx, { CxProps } from 'fe-core/util/withCx';
import Box from 'fe-design-base/atoms/Box';
import Icon, { IconName } from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import { MENU_HELPER_TEXT_MAX_WIDTH } from 'fe-design-base/styles/constants';

interface SimpleMenuItemProps extends MenuItemProps {
  /**
   * Icon to be displayed on the left side of the menu item
   */
  iconName?: IconName;

  /**
   * Text to be displayed on the menu item
   */
  label?: string;
  redText?: boolean;
  id?: string;
  dataTestId?: string;
  /**
   * onClick handler for the menu item
   */
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  /**
   * If true, a thin bottom border will be displayed on the menu item
   * @default false
   * */
  ref?: RefObject<HTMLLIElement>;
  helperText?: string | string[];
}

const SimpleMenuItem = ({
  label,
  iconName,
  onClick,
  id,
  dataTestId,
  cx,
  disabled,
  redText,
  helperText,
}: // helperNode = null,
SimpleMenuItemProps & CxProps) => (
  <>
    <MenuItem
      id={id}
      data-testid={dataTestId}
      className={cx({ disabled }, { redText })}
      onClick={onClick}
    >
      {iconName && (
        <Icon
          size="medium"
          iconName={iconName}
          color={redText ? 'error300' : 'mono700'}
          dataTestId="simple-menu-item-icon"
        />
      )}
      <Text variant="bodyTight">{label}</Text>
    </MenuItem>
    {helperText && (
      <Box
        ml={iconName ? 40 : 12}
        mv={4}
        maxw={MENU_HELPER_TEXT_MAX_WIDTH}
        dataTestId="simple-menu-item-helper-text"
      >
        {Array.isArray(helperText) ? (
          helperText.map(text => (
            <Text key={text} color="mono500" variant="bodyTight">
              {text}
            </Text>
          ))
        ) : (
          <Text color="mono500" variant="bodyTight">
            {helperText}
          </Text>
        )}
      </Box>
    )}
  </>
);

export default withCx<SimpleMenuItemProps>('FDBSimpleMenuItem')(SimpleMenuItem);
